var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9455 1C15.545 1.00097 15.1488 1.08122 14.7795 1.23611C14.4102 1.39101 14.0753 1.61749 13.794 1.90249L2.08683 13.6089L2.04093 13.8406L1.23099 17.9126L1 18.9994L2.08758 18.7684L6.1595 17.9585L6.39049 17.9118L18.0977 6.20541C18.3834 5.92461 18.6104 5.58971 18.7653 5.22026C18.9202 4.85081 19 4.4542 19 4.05358C19 3.65296 18.9202 3.25635 18.7653 2.8869C18.6104 2.51744 18.3834 2.18255 18.0977 1.90175C17.8162 1.6168 17.4811 1.3904 17.1117 1.23563C16.7424 1.08086 16.346 1.00078 15.9455 1V1ZM15.9455 2.41111C16.3186 2.41111 16.6947 2.58139 17.056 2.94342C17.7763 3.66304 17.7763 4.44411 17.056 5.16447L16.5244 5.67309L14.3256 3.47499L14.8349 2.94342C15.197 2.58139 15.5723 2.41111 15.9455 2.41111V2.41111ZM13.2854 4.51667L15.4827 6.71477L6.52968 15.6671C6.04634 14.7214 5.27684 13.9524 4.33084 13.4697L13.2854 4.51667ZM3.38319 14.6735C3.82136 14.8498 4.21938 15.1128 4.55334 15.4468C4.88731 15.7808 5.15033 16.1788 5.32661 16.617L2.89678 17.1026L3.38319 14.6735Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditWhite);
export default __webpack_public_path__ + "static/media/edit-white.92fa187e.svg";
export { ForwardRef as ReactComponent };